import React from "react";
import { ArrowDown, ArrowUp, ChevronsUpDown } from "lucide-react";
import "./sorting.css";

/** Intestazione di colonna ordinabile: click per ordinare, accessibile da tastiera, con aria-sort. */
export const SortableTh = ({ label, sortKey, kind = "text", sort, onSort, className = "", testId, children, title }) => {
  const active = sort?.key === sortKey && !!sort?.dir;
  const Icon = active ? (sort.dir === "asc" ? ArrowUp : ArrowDown) : ChevronsUpDown;
  return <th className={`sortable${active ? " sorted" : ""}${className ? ` ${className}` : ""}`}
    aria-sort={active ? (sort.dir === "asc" ? "ascending" : "descending") : "none"}>
    <button type="button" data-testid={testId || `sort-${sortKey}`} title={`${title ? `${title} · ` : ""}Ordina per ${label}`}
      onClick={() => onSort(sortKey, kind)}>
      <span>{children || label}</span>
      <Icon size={12} aria-hidden="true" />
      <em className="sort-state">{active ? (sort.dir === "asc" ? "ordine crescente" : "ordine decrescente") : "non ordinata"}</em>
    </button>
  </th>;
};

/** Variante per le "tabelle" costruite con griglie di div (stesso comportamento dell'intestazione tabellare). */
export const SortHeadCell = ({ label, sortKey, kind = "text", sort, onSort, testId }) => {
  const active = sort?.key === sortKey && !!sort?.dir;
  const Icon = active ? (sort.dir === "asc" ? ArrowUp : ArrowDown) : ChevronsUpDown;
  return <span className={`sort-head${active ? " sorted" : ""}`} role="columnheader"
    aria-sort={active ? (sort.dir === "asc" ? "ascending" : "descending") : "none"}>
    <button type="button" data-testid={testId || `sort-${sortKey}`} title={`Ordina per ${label}`} onClick={() => onSort(sortKey, kind)}>
      {label}<Icon size={12} aria-hidden="true" />
    </button>
  </span>;
};
